export default "Écoles, gymnases, éclairage public : des dizaines de compteurs aux puissances souvent héritées. Revue TURPE du parc, économies de fonctionnement récurrentes sans marché de travaux.";
